import { sameMembers } from '@nx-smartmonkey/shared/helpers';
import { SelectionActionType } from '../../context/selection/actions';
import { useSelectionContext } from '../../context/selection/context';

type UseSetActivePlanSelectedStopsResponse = {
  setSelectedDrivers: (selectedDrivers: Array<string>) => void;
  selectedDrivers: Array<string>;
  selectDriverFromMap: ({ driverId, withControlKey }: { driverId: string; withControlKey?: boolean }) => void;
};

// Hooks act as 'Adapter' layer.
export const useSetActivePlanSelectedDrivers = (): UseSetActivePlanSelectedStopsResponse => {
  const { selectionState, selectionDispatch } = useSelectionContext();

  const setSelectedDrivers = (selectedDrivers: Array<string>) => {
    if (!sameMembers(selectionState.selectedDrivers, selectedDrivers)) {
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS,
        payload: {
          selectedDrivers,
        },
      });
    }
  };

  const selectDriverFromMap = ({ driverId, withControlKey }: { driverId: string; withControlKey?: boolean }) => {
    selectionDispatch({
      type: SelectionActionType.ON_SELECT_DRIVER,
      payload: {
        driverId,
        withControlKey,
      },
    });

    if (selectionState.selectedStops.length > 0) {
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_STOPS,
        payload: {
          selectedStops: [],
        },
      });
    }
  };

  return {
    setSelectedDrivers,
    selectedDrivers: selectionState.selectedDrivers,
    selectDriverFromMap,
  };
};
